export default __webpack_public_path__ + "static/modularfrp3-9e495df7e18bbede9494ff4fb13aadfa.jpg";